import React, { useContext } from "react";
import { useSelector } from "react-redux";
import ZuoraPayment from "../../ZuoraPayment/ZuoraPayment";
import { PAYMENT_TYPE, PAYMENT_OPTIONS } from "../../../constants/AppConstants";
import { Container } from "reactstrap";
import { UpdatePaymentInfoContext } from "../../../pages/Account/EditAccount/EditPayment";
import GooglePay from "./ZuoraGpayPayment";

const ZuoraPaymentForm = (props) => {
    const { signUpType, paymentOptions } = props;
    const updatePaymentInfo = useContext(UpdatePaymentInfoContext);
    const { accountInfo, paymentType } = updatePaymentInfo;
    const paymentOptionsResp = useSelector(state => state.PaymentOptions);
    return (
        <>
            {
                (paymentType && paymentType === PAYMENT_TYPE.UPDATE)
                ? <ZuoraPayment accountInfo={accountInfo} paymentType={PAYMENT_TYPE.UPDATE}></ZuoraPayment>
                : <ZuoraPayment paymentType={PAYMENT_TYPE.NEW} signUpType={signUpType}></ZuoraPayment>
            }
                <div>
                    {
                    Array.isArray(paymentOptionsResp?.data) && 
                    paymentOptionsResp?.data?.some(opt => opt.paymentMethodName === PAYMENT_OPTIONS.GOOGLE_PAY ) &&
                    paymentOptions !== PAYMENT_OPTIONS.DIRECT_BANK_TRANSFER &&
                        <div>
                            <GooglePay publishableKey= {window.env.PUBLISHABLE_KEY} paymentType={paymentType}/>
                        </div>
                    }
                    <Container id="zuora_payment"></Container>
                </div>
        </>
    )
}

export default ZuoraPaymentForm;